import { useAppSelector } from "@/services/hooks";
import React, { useEffect, useState } from "react";
 
import api from "@/services/api";
import CountryAccessDisplayView from "./CountryAccessDisplayView";

/** A row of GET /api/sites/searchByCountry/:code; the view reads `_id` and its name fields. */
type CountrySite = { _id: string };

export type CountryAccessDisplayContainerProps = {
  /** The country's display label. */
  name: string;
  /** The country code the sites are fetched for. */
  value: string;
  /** The user's current per-site permission rows; the view matches them by `siteId`. */
  oldPermissionUpdateForm?: { siteId?: unknown }[];
};

const CountryAccessDisplayContainer = ({
  name,
  value,
  oldPermissionUpdateForm,
}: CountryAccessDisplayContainerProps) => {
  const [sites, setSites] = useState<CountrySite[]>([]);
  const [error, setError] = useState<unknown>(null);

  // Optional parity with old class (not used but available if needed)
  const user = useAppSelector((state) => state.users.register_user);

  useEffect(() => {
    let alive = true;

    const fetchSites = async () => {
      try {
        const { data } = await api.get(
          `/api/sites/searchByCountry/${value}`
        );
        if (alive) setSites(Array.isArray(data) ? data : []);
      } catch (e) {
        if (alive) setError(e);
      }
    };

    fetchSites();
    return () => {
      alive = false;
    };
  }, [value]);

  return (
    <CountryAccessDisplayView
      name={name}
      sites={sites}
      error={error}
      oldPermissionUpdateForm={oldPermissionUpdateForm}
    />
  );
};

export default CountryAccessDisplayContainer;
